/* The plan library — KANON `Programy v2 - D3 (0.8)`, the master-detail pane.
 *
 * ── The SHELL is `shared/ui/canonScreen`, and the HEADER is `shared/ui/screenHeader` ─────────
 * `.page` and `.measure` are not here, and neither is the title band. Both moved out on their
 * second consumer: this screen and the clients roster share a measure, an inset and a header band
 * value for value, and the owner's 11 August disposition — "nagłówki mają się kończyć w tym samym
 * miejscu" — is only true while one file declares them.
 *
 * What is left is what only THIS screen has: the two panes, and the card they are both cut from.
 *
 * ── Both panes are cards, so `.card` is written once ─────────────────────────────────────────
 * The canon builds them from one `paneShell()` — 11px radius, a `--border` hairline, `--bg-card`,
 * `--shadow-card` — and gives the list a width and the inspector the rest. Two classes carrying six
 * identical declarations is the near-duplicate the value discipline exists to prevent, so the
 * shared half is a class of its own and each pane wears it plus its own.
 *
 * ── Each pane scrolls INSIDE itself, which is what fit-or-scroll means here ──────────────────
 * `min-height: 0` on the pane is what makes that real: a flex item's default `min-height: auto`
 * refuses to shrink below its content, so without it the pane grows to the height of the longest
 * library and the page scrolls instead of the list. The list's own scroller is in
 * `ListRows.module.css`; the inspector scrolls itself.
 *
 * No width query. At the app's 1280×620 floor the measure is 1156px inside the rail and its inset,
 * the list takes 461 and the gap 13, and the inspector still has 682 — comfortably past anything it
 * needs. The roster hides its panel below 1394 because its TABLE has a track sum that cannot
 * compress; a 461px list of 61px rows has nothing to compress.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

.pane {
  display: flex;
  flex: 1;
  gap: var(--space-13px);
  min-height: 0;
  overflow: hidden;
}

.card {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-11px);
  box-shadow: var(--shadow-card);
}

/* Fixed, and the inspector takes the surplus on a wide monitor: a list of 61px rows gains nothing
 * from being wider, and the canon's own rule is that free space goes to the margins and to the
 * detail rather than into stretched columns. */
.list {
  flex: none;
  width: var(--w-pl-list);
}

/* The inspector's box, and the pane it scrolls in. It stands from the FIRST frame at the canon's
 * exact geometry rather than appearing when a read lands — a column that arrives with its data is
 * the jump this repository treats as a defect, and reserving the box is the whole of the loading
 * policy's first rule. `overflow-y: auto` is what makes the expanded follower list fit-or-scroll:
 * measured at 1280x620 it stands 291px past the pane's foot and the pane's own scroller reaches
 * every row, with no document scroll. */
.inspector {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
}
